import { useEffect } from 'react';
import { Alert } from '@billda/design-system';

export interface PageSnackbarState {
  open: boolean;
  message: string;
  severity: 'success' | 'error';
}

interface PageSnackbarProps {
  snackbar: PageSnackbarState;
  onClose: () => void;
  /** Auto-dismiss delay in ms (default 4000, matching MUI Snackbar). */
  autoHideDuration?: number;
}

/**
 * Bottom-centre transient message, replacing the pages' MUI
 * Snackbar + filled Alert pair with the DS Alert over a fixed anchor.
 */
export function PageSnackbar({
  snackbar,
  onClose,
  autoHideDuration = 4000,
}: PageSnackbarProps) {
  useEffect(() => {
    if (!snackbar.open) {
      return;
    }
    const timer = window.setTimeout(onClose, autoHideDuration);
    return () => {
      window.clearTimeout(timer);
    };
  }, [snackbar.open, snackbar.message, onClose, autoHideDuration]);

  if (!snackbar.open) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2">
      <Alert
        onClose={onClose}
        severity={snackbar.severity}
        variant="filled"
        className="w-full"
      >
        {snackbar.message}
      </Alert>
    </div>
  );
}
